// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1kPcn","actions":"GroupTable_actions__2_BUk","deleteModalFooter":"GroupTable_deleteModalFooter__1ii6q"};